import React, { useMemo, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Divider, Grid } from '@mui/material';
import { useMessages } from 'modules/intl';
import { NoteInsightsViewOptions } from '../Notes/NoteInsightsContextProvider';
import NavigatorWithoutPicker from '../components/InsightsDateRangeNavigator/NavigatorWithoutPicker';
import { useSupervisorInsightContext } from '../Notes/SupervisorInsightContextProvider';
import InsightSearchBox from './InsightSearchBox';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: theme.spacing(8),
    alignItems: 'center'
  }
}));

const messageIds = [
  'insights.viewOptions.thisMonth',
  'insights.viewOptions.thisWeek',
  'insights.viewOptions.lastNinetyDays'
];

const SupervisorHeader: React.FC = () => {
  const classes = useStyles();
  const [disableNextSupervisor, setDisableNextSupervisor] = useState(false);
  const [disablePreviousSupervisor, setDisablePreviousSupervisor] = useState(
    false
  );
  const messages = useMessages(messageIds);

  const viewOptions = useMemo(
    () => [
      {
        value: NoteInsightsViewOptions.THIS_WEEK,
        text: messages['insights.viewOptions.thisWeek']
      },
      {
        value: NoteInsightsViewOptions.THIS_MONTH,
        text: messages['insights.viewOptions.thisMonth']
      },
      {
        value: NoteInsightsViewOptions.LAST_NINETY_DAYS,
        text: messages['insights.viewOptions.lastNinetyDays']
      }
    ],
    [messages]
  );
  const {
    currentPeriod,
    setcurrentPeriod,
    selectedViewOptionSupervisor,
    setSelectedViewOptionSupervisor
  } = useSupervisorInsightContext();
  return (
    <>
      <Grid
        container
        className={classes.container}
        data-testid="supervisor-header"
        justifyContent={'space-between'}
        rowGap={2}
      >
        <Grid item xs={12} md={12} lg={7} xl={6} alignItems={'center'}>
          <NavigatorWithoutPicker
            disablePrevious={disablePreviousSupervisor}
            setDisablePrevious={setDisablePreviousSupervisor}
            disableNext={disableNextSupervisor}
            setDisableNext={setDisableNextSupervisor}
            viewOptions={viewOptions}
            currentPeriod={currentPeriod}
            setCurrentPeriod={setcurrentPeriod}
            setSelectedViewOption={setSelectedViewOptionSupervisor}
            selectedViewOption={selectedViewOptionSupervisor}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          lg={5}
          xl={6}
          paddingRight={5}
          alignItems={'center'}
        >
          <InsightSearchBox />
        </Grid>
      </Grid>
      <Divider />
    </>
  );
};

export default React.memo(SupervisorHeader);
